// extracted by mini-css-extract-plugin
module.exports = {"downloadGraphics":"DownloadGraphics_downloadGraphics__yc155"};